import { Network, Percent, ShieldCheck, PhoneCall, Timer, Layers } from "lucide-react";

export const PHONE_DISPLAY = "(863) 559-8288";
export const TEL_HREF = "tel:8635598288";
export const EMAIL = "jspellman@nexalending.com";
export const MAILTO = "mailto:jspellman@nexalending.com";
export const CALENDLY = "https://calendly.com/jspellman-3/mortgage-solutions-call";
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/search/Family+First+Mortgage+USA+empowered+by+NEXA";
export const NMLS_URL =
  "https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1660690";
export const AXEN_URL = "https://earnwithaxen.com/";

export const SOCIALS = {
  facebook: "https://www.facebook.com/people/Family-First-Mortgage-USA/61556568118699/",
  instagram: "https://www.instagram.com/familyfirstmortgageusa/",
  youtube: "https://www.youtube.com/@familyfirstmortgageusa",
  linkedin: "https://www.linkedin.com/in/joespellman/",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Loan Programs", to: "/loan-programs" },
  { label: "Loan Process", to: "/loan-process" },
  { label: "About Joe", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const PARTNER_LINKS = [
  { icon: "trend", title: "Earn with Axen", sub: "Build multiple income streams", href: AXEN_URL, external: true },
  { icon: "headset", title: "AXEN Realty Support", sub: "Live support & real estate tools", href: "https://axenrealty.com/live-support", external: true },
  { icon: "building", title: "NEXA Lending", sub: "#1 broker in the nation", href: "https://nexalending.com/", external: true },
  { icon: "users", title: "Join Our Team", sub: "Recruiting & career opportunities", href: "/#join-team", external: false },
  { icon: "key", title: "FSBO Resources", sub: "Selling your home? Joe can help", href: "/contact", external: false },
];

export const HERO_STATS = [
  { value: "55+", label: "5-Star Reviews" },
  { value: "9–16 Days", label: "Average Close Time" },
  { value: "320+", label: "Lender Partners" },
  { value: "NMLS #2142845", label: "Licensed & Regulated" },
];

export const RECRUIT_STATS = [
  { value: "#1", label: "Brokerage in the U.S." },
  { value: "4,000+", label: "Loan Officers" },
  { value: "320+", label: "Lenders Shopped" },
  { value: "Top-Tier", label: "Comp & Rates" },
];

export const TRUST_ITEMS = [
  { lead: "5.0 Google Rating", rest: "55 Verified Reviews", google: true },
  { lead: "Best of 2026", rest: "Award Winner · BusinessRate · Spring Hill, FL" },
  { lead: "NEXA — #1 Mortgage Broker", rest: "Largest Broker in the Nation" },
  { lead: "Branch NMLS #2729829", rest: "Personal NMLS #2142845" },
];

export const WHY_CARDS = [
  {
    title: "Banks Compete For You",
    desc: "We shop 320+ lenders simultaneously — not just one — so you get the best rate available, not just what one institution offers.",
  },
  {
    title: "Transparent Process",
    desc: "Banks bury their profit inside your interest rate — you never see it. Joe shows you every fee upfront, clearly, so you can compare apples to apples. No hidden markups. No surprises at the closing table.",
  },
  {
    title: "Credit-Safe Process",
    desc: "We review your numbers before touching your credit. No surprises, no unnecessary hard inquiries.",
  },
];

export const BENEFITS = [
  {
    icon: Network,
    title: "320+ Lenders Compete For You",
    desc: "As a mortgage broker, Joe shops your loan with over 320 banks and lenders simultaneously — not just one institution — so you always get the best rate available.",
  },
  {
    icon: Percent,
    title: "Competitive Rates — Real Savings",
    desc: "As a broker, Joe shops your loan across 320+ lenders to find the most competitive rate for your situation. More lenders competing for your business means better pricing than what any single bank can offer.",
  },
  {
    icon: ShieldCheck,
    title: "Credit-Safe Pre-Approval",
    desc: "We review your complete financial picture before touching your credit. No surprises, no unnecessary hard inquiries until you're fully ready.",
  },
  {
    icon: PhoneCall,
    title: "Direct Access to Joe",
    desc: "You work directly with Joe — not a call center, not a junior processor. He answers his phone and responds to texts personally, even evenings and weekends.",
  },
  {
    icon: Timer,
    title: "Fast Closings — 9 to 16 Days",
    desc: "Joe closes in 9–16 days on average — well under the industry standard. Faster closings reduce your Rate Lock per diem costs and give sellers confidence your deal will close on time.",
  },
  {
    icon: Layers,
    title: "Every Loan Type Available",
    desc: "Conventional, FHA, VA, USDA, Jumbo, Down Payment Assistance, Investment properties, and more. If a loan program exists, Joe can access it.",
  },
];

export const BIO_1 =
  "Joe Spellman is the Branch Manager of Family First Mortgage USA, powered by NEXA Lending — the #1 mortgage broker in the nation. With access to 320+ lenders and a deep commitment to putting families first, Joe delivers the competitive rates and personal service that big banks simply cannot provide. Whether you are a homebuyer, a mortgage professional looking to grow through NEXA Lending, or a real estate agent building your business with AXEN Realty, Joe has a platform and a path for you.";

export const PROGRAMS_PREVIEW = [
  { name: "Conventional", tagline: "The most versatile financing option" },
  { name: "FHA", tagline: "Government-backed with lower barriers" },
  { name: "VA", tagline: "Exclusive benefits for those who served" },
  { name: "Refinance", tagline: "Optimize the mortgage you already have" },
];

export const PROGRAMS = [
  {
    name: "Conventional Loans",
    tagline: "The most versatile financing option",
    desc: "Conventional loans offer flexible terms and competitive rates for buyers with solid credit. With as little as 3% down, they're ideal for those who want to preserve cash while still securing a great rate.",
    bullets: [
      "As low as 3% down payment",
      "Competitive fixed and adjustable rates",
      "No upfront mortgage insurance premium",
      "Available for primary, second, and investment homes",
    ],
  },
  {
    name: "FHA Loans",
    tagline: "Government-backed with lower barriers",
    desc: "FHA loans are insured by the Federal Housing Administration, allowing buyers with lower credit scores or limited savings to qualify. A popular choice for first-time homebuyers.",
    bullets: [
      "Down payments as low as 3.5%",
      "Credit scores as low as 580 may qualify",
      "Flexible debt-to-income requirements",
      "Gift funds allowed for down payment",
    ],
  },
  {
    name: "VA Loans",
    tagline: "Exclusive benefits for those who served",
    desc: "VA loans are one of the most powerful mortgage benefits available — offering zero down payment, no private mortgage insurance, and competitive rates exclusively for veterans and active-duty military.",
    bullets: [
      "Zero down payment required",
      "No private mortgage insurance",
      "Competitive interest rates",
      "Available for purchase and refinance",
    ],
  },
  {
    name: "USDA Loans",
    tagline: "100% financing for eligible areas",
    desc: "USDA loans provide 100% financing for homes in eligible rural and suburban areas. If your target property qualifies, this is one of the most cost-effective paths to homeownership available.",
    bullets: [
      "No down payment required",
      "Below-market interest rates",
      "Low monthly mortgage insurance",
      "Available for eligible rural and suburban areas",
    ],
  },
  {
    name: "Refinance",
    tagline: "Optimize the mortgage you already have",
    desc: "Whether you want to lower your rate, shorten your term, or tap into your home's equity, refinancing can be a powerful financial tool. Joe will analyze your current loan and identify the best path forward.",
    bullets: [
      "Rate and term refinance",
      "Cash-out refinance",
      "FHA and VA streamline options",
      "No-cost refinance options available",
    ],
  },
  {
    name: "Jumbo Loans",
    tagline: "Financing for high-value properties",
    desc: "Jumbo loans finance properties that exceed conventional loan limits. With access to multiple jumbo lenders, Joe can find competitive rates even for high-value purchases.",
    bullets: [
      "Loans above conforming limits",
      "Fixed and adjustable options",
      "Primary, second, and investment homes",
      "Competitive jumbo pricing",
    ],
  },
];

export const PROCESS_PREVIEW = [
  { title: "Free Consultation", desc: "We discuss your goals, timeline, and financial picture — no commitment required." },
  { title: "Get Pre-Approved", desc: "We review your file and issue a pre-approval letter so you can shop with confidence." },
  { title: "Find Your Home", desc: "Shop knowing exactly what you can afford. We're available throughout." },
  { title: "Close & Celebrate", desc: "We handle every detail from underwriting to closing day." },
];

export const STEPS = [
  {
    num: "01",
    name: "Free Consultation",
    timing: "Day 1",
    desc: "Your journey starts with a no-pressure conversation. Joe will learn about your goals, timeline, and financial situation to determine the best path forward.",
    bullets: [
      "Discuss your homeownership goals",
      "Review your financial situation",
      "Identify the best loan programs for you",
      "Answer all your questions in plain English",
      "No obligation — just honest guidance",
    ],
  },
  {
    num: "02",
    name: "Application & Pre-Approval",
    timing: "Days 2–3",
    desc: "We gather your documents and submit your application. Joe shops your scenario across 320+ lenders to find the best rate and terms before running your credit.",
    bullets: [
      "Complete the mortgage application",
      "Gather required documents (income, assets, ID)",
      "Joe reviews your scenario with multiple lenders",
      "Receive your pre-approval letter",
      "Credit is only pulled after you're ready",
    ],
  },
  {
    num: "03",
    name: "Home Shopping",
    timing: "Weeks 2–8",
    desc: "Armed with your pre-approval letter, you can shop with confidence. Joe is available throughout to answer questions and adjust your financing as needed.",
    bullets: [
      "Shop with a strong pre-approval in hand",
      "Joe answers questions as they arise",
      "Rate lock options available when you find your home",
      "Adjust loan amounts as needed",
      "Guidance on making competitive offers",
    ],
  },
  {
    num: "04",
    name: "Offer Accepted",
    timing: "Day of Offer",
    desc: "Once your offer is accepted, we move quickly. Joe coordinates with your real estate agent to ensure a smooth transition from contract to closing.",
    bullets: [
      "Formal loan application submitted",
      "Rate lock secured",
      "Home inspection coordination",
      "Appraisal ordered",
      "Title search initiated",
    ],
  },
  {
    num: "05",
    name: "Underwriting & Approval",
    timing: "",
    desc: "Your file goes to underwriting for final review. Joe monitors the process closely and communicates with you every step of the way.",
    bullets: [
      "Underwriter reviews your complete file",
      "Appraisal reviewed and approved",
      "Any conditions are addressed quickly",
      "Clear to close issued",
    ],
  },
  {
    num: "06",
    name: "Closing Day",
    timing: "",
    desc: "Sign your documents, get your keys, and celebrate. Joe will be there to make sure everything goes smoothly.",
    bullets: [
      "Review your Closing Disclosure",
      "Sign final documents",
      "Receive your keys",
    ],
  },
];

export const REVIEWS = [
  {
    name: "Denver Lane",
    initials: "DL",
    quote:
      "Working with Joe Spellman and the team at Family First Mortgage was hands down one of the best decisions we made during our home buying process. From day one, Joe proved he's not just knowledgeable — he's on another level. Every question we had, he answered clearly, quickly, and with total confidence. He genuinely knows this business inside and out.",
  },
  {
    name: "Anthony Rodriguez",
    initials: "AR",
    quote:
      "My wife and I bought our first home and it felt like an impossible mountain to climb until Joe stepped in to guide us. He took the time to break down the complex financial part, ensuring we felt confident and informed at every step. From locking in a good interest rate to navigating the mountain of paperwork with incredible patience, Joe was the steady hand we needed.",
  },
  {
    name: "Karen Licciardi",
    initials: "KL",
    quote:
      "Joe and his team did an unbelievable job getting my very first home. I am self employed and I was definitely unsure if I would even be able to qualify. But Joe said from day one 'I can get this done!' I did trust him and thank GOD I did!! I'm now a new home owner. His communication was awesome and his knowledge to every detail was incredible!",
  },
  {
    name: "Ada Maldonado",
    initials: "AM",
    quote:
      "Working with Joe Spellman was great — he was always available to answer any question we might have had and very patient with us, taking the time to explain everything step by step. He kept us very well informed and up to date on everything. I would highly recommend Joe Spellman to anyone trying to buy a home. Excellent customer service.",
  },
  {
    name: "Cathy Rostorfer",
    initials: "CR",
    quote:
      "Joseph Spellman and his group were the best people to have on my side. Everyone was helpful and did everything to help me through the process of my home loan. I will recommend them to everyone.",
  },
  {
    name: "Janet C.",
    initials: "JC",
    quote:
      "Easy to apply and Joseph kept us informed the entire time until closing. We were ready to close in just 9 days — which is the quickest turnaround experience I have ever had in trying to obtain a mortgage.",
  },
];

export const ABOUT_STATS = [
  { value: "320+", label: "Lender Partners" },
  { value: "9–16", label: "Days Average Close Time" },
  { value: "5★", label: "Client Rating" },
  { value: "#2729829", label: "Branch — Licensed & Regulated" },
];
